<template>
  <div>
    <Header />
    <modal name="pay" :width="800" :height="600" :adaptive="true">
      <ModalStripe
        :clientSecret="clientSecret"
        :price="price"
        :numberRef="numberRef"
      />
    </modal>
    <modal
      name="pay-checkout"
      :width="600"
      :height="900"
      :adaptive="true"
      :scrollable="true"
    >
      <ModalStripeCheckout
        :clientSecret="clientSecret"
        :numberRef="numberRef"
        :price="price"
      />
    </modal>
    <modal
      name="confirm"
      :width="400"
      :height="200"
      :adaptive="true"
      :clickToClose="false"
    >
      <h1>{{ $func.parseIso("successfulPayment") }}</h1>
      <h3>Se le enviara toda la información via email.</h3>
      <h4>Segundos: {{ count }}</h4>
    </modal>
    <modal
      name="mobile-summary"
      :width="420"
      :height="560"
      :adaptive="true"
      :scrollable="true"
      classes="mobile-summary-modal"
    >
      <div class="mobile-summary-head">
        <button
          type="button"
          class="mobile-summary-close"
          @click="$modal.hide('mobile-summary')"
        >
          <i class="fa-regular fa-close"></i>
        </button>
      </div>
      <div class="mobile-summary-body">
        <SummaryCard
          :week="week"
          :selectedUnit="selectedUnit"
          :step="step"
          :remaining="remaining"
          :timerFormatted="timerFormatted"
          :msgBtn="msgBtn"
          :traveler="travelerData"
          @book="onMobileBookConfirm"
        />
      </div>
    </modal>

    <div class="main only-hotel">
      <div
        id="carousel:modal:modalCargando"
        class="c-modal modalCargando c-modal-waiting setup-modal-back-button"
        data-size="small"
        role="dialog"
        data-closeable="false"
        tabindex="-1"
        aria-modal="true"
        data-active="false"
      ></div>
      <div id="carousel:destinations-photos" class="destinations-photos">
        <div
          class="fotos"
          style="display: none"
          data-city-name="Miami FL, United States of America"
          data-index="0"
          data-photo-0="https://cdn5.travelconline.com/unsafe/fit-in/500x0/filters:quality(75):format(webp)/https%3A%2F%2Ftr2storage.blob.core.windows.net%2Fimagenes%2FJzV9iszVbivw-7qvVLRqSHmWgDjd.jpeg"
          data-photo-1="https://cdn5.travelconline.com/unsafe/fit-in/500x0/filters:quality(75):format(webp)/https%3A%2F%2Ftr2storage.blob.core.windows.net%2Fimagenes%2FNGVTPelyHJ1w-ibBH4MC1XafyaOv.jpeg"
          data-photo-2="https://cdn5.travelconline.com/unsafe/fit-in/500x0/filters:quality(75):format(webp)/https%3A%2F%2Ftr2storage.blob.core.windows.net%2Fimagenes%2FEjm3zZbrL0mN-q80y6tLnvdUsg1a.jpeg"
          data-photo-3="https://cdn5.travelconline.com/unsafe/fit-in/500x0/filters:quality(75):format(webp)/https%3A%2F%2Ftr2storage.blob.core.windows.net%2Fimagenes%2Fns6PdRaWRezt-aCezS6vw9rmKjBi.jpeg"
          data-photo-4="https://cdn5.travelconline.com/unsafe/fit-in/500x0/filters:quality(75):format(webp)/https%3A%2F%2Ftr2storage.blob.core.windows.net%2Fimagenes%2Fp17DmpYVIY5M-Hyw3UDgwTMshbNH.jpeg"
          data-photo-5="https://cdn5.travelconline.com/unsafe/fit-in/500x0/filters:quality(75):format(webp)/https%3A%2F%2Ftr2storage.blob.core.windows.net%2Fimagenes%2FLsVsiozDaEm4-H81alUcYCQDmgZ6.jpeg"
          data-photo-6="https://cdn5.travelconline.com/unsafe/fit-in/500x0/filters:quality(75):format(webp)/https%3A%2F%2Ftr2storage.blob.core.windows.net%2Fimagenes%2FtZfvCLOYmEM7-wqIraDSaJmtrx8Y.jpeg"
        ></div>
      </div>
      <div id="error-panel" class="error-panel"></div>
      <div
        id="hotelMapModal"
        class="c-modal hotelMapModal c-modal--onmobile-fullscreen setup-modal-back-button"
        data-size="large"
        role="dialog"
        data-closeable="true"
        tabindex="-1"
        aria-modal="true"
        data-active="false"
      >
        <div class="c-modal__backmask"></div>
        <div class="c-modal__wrapper">
          <div class="c-modal__container">
            <div class="c-modal__close" style="">
              <button
                type="button"
                class="c-modal__close-btn"
                data-dismiss="modal"
              >
                <span
                  class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
                >
                  Close
                  <i
                    class="fa-solid fa-caret-right u-font-size--default"
                  ></i></span
                ><i class="u-display--block fa-regular fa-close"></i>
              </button>
            </div>
            <div class="c-modal__body">
              <div
                class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
              ></div>
              <div class="hotelDataSheet">
                <div class="c-microservice c-microservice--hotel-map">
                  <div class="c-microservice__primary">
                    <div class="c-microservice__main p-0 u-border--none">
                      <div class="c-microservice__body">
                        <div class="c-microservice__content">
                          <span
                            id="openHotelMiniMap"
                            onclick="true &amp;&amp; !isInIframe() ? '' : travelc.pushViewStateToHistory()"
                          >
                            <div class="c-microservice__heading">
                              <b class="c-microservice__title mt-5"
                                >Clarion Inn &amp; Suites Miami International
                                Airport</b
                              >
                              <div
                                class="c-hotel-status null mt-5"
                                style="visibility: hidden"
                              >
                                <span class="c-hotel-status__category null"
                                  ><i
                                    class="fa-solid fa-star c-hotel-status__star"
                                  ></i
                                  ><i
                                    class="fa-solid fa-star c-hotel-status__star"
                                  ></i
                                  ><i
                                    class="fa-solid fa-star c-hotel-status__star hidden"
                                  ></i
                                  ><i
                                    class="fa-solid fa-star c-hotel-status__star hidden"
                                  ></i
                                  ><i
                                    class="fa-solid fa-star c-hotel-status__star hidden"
                                  ></i
                                  ><i
                                    class="fa-solid fa-star c-hotel-status__star hidden"
                                  ></i
                                ></span>
                              </div>
                            </div>
                            <div class="c-microservice__details">
                              <span class="c-microservice__detail">
                                <i class="fa-regular fa-link"></i
                                ><b> Chain: </b> &nbsp; Choice hotels </span
                              ><span class="c-microservice__detail">
                                <i class="fa-regular fa-map-marker-alt"></i
                                ><b>Address: </b>
                                &nbsp; 5301 nw 36th st, Miami springs 33166
                              </span>
                            </div></span
                          >
                        </div>
                      </div>
                      <div class="c-microservice__map-section">
                        <div
                          style="height: 500px"
                          class="c-microservice__map c-microservice__map--lg"
                          data-marker-target="_blank"
                          data-availposition="1"
                          data-hotelname="Clarion Inn &amp; Suites Miami International Airport"
                          data-market-feature="true &amp;&amp; !isInIframe() ? '' : travelc.pushViewStateToHistory()"
                          data-marker-link=""
                          data-latitude="25.807934"
                          data-is-apartment="false"
                          data-longitude="-80.28269"
                          data-code="72651"
                        >
                          <div id="hotel-map-container"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="confirmOutcomeActivities"
        class="ui-confirm-dialog ui-dialog ui-widget ui-widget-content ui-corner-all ui-shadow ui-hidden-container confirmOutcomeActivities"
        role="alertdialog"
        aria-describedby="confirmOutcomeActivities_content"
        aria-hidden="true"
        aria-modal="true"
        aria-labelledby="confirmOutcomeActivities_title"
        style="width: auto; height: auto"
      >
        <div
          class="ui-dialog-titlebar ui-widget-header ui-helper-clearfix ui-corner-top"
        >
          <span id="confirmOutcomeActivities_title" class="ui-dialog-title"
            >Activities</span
          >
        </div>
        <div
          class="ui-dialog-content ui-widget-content"
          id="confirmOutcomeActivities_content"
          style="height: auto"
        >
          <span class="ui-icon ui-icon-false ui-confirm-dialog-severity"></span
          ><span class="ui-confirm-dialog-message"
            >Would you like to see activities in Miami FL?</span
          >
        </div>
        <div
          class="ui-dialog-buttonpane ui-dialog-footer ui-widget-content ui-helper-clearfix"
        >
          <div class="o-flexbox o-flexbox--generic-row o-group--small pt-10">
            <a
              href="/ticket/ticketAvailability.xhtml?tripId=8"
              onclick="PF('block').show(); PF('confirmOutcomeActivities').hide();"
              class="c-button bg-clr--brand continue-tickets"
            >
              Yes </a
            ><a
              href="/summary.xhtml?tripId=8"
              onclick="PF('block').show(); PF('confirmOutcomeActivities').hide();"
              class="c-button bdr-clr--brand continue-summary"
            >
              No
            </a>
          </div>
        </div>
      </div>
      <span class="js-mobile-navigation--accommodation-detail"></span>
      <div
        class="c-sticky-header c-sticky-header--hidden o-position o-position--fixed u-1/1 u-zindex--128"
        style="top: -60px"
      >
        <div class="o-container o-container--large o-box--tiny--vertical">
          <div class="u-display--flex u-gap--tiny" style="height: 50px">
            <div class="c-navigation-availability__text">
              <div class="c-navigation-availability-title">
                <div
                  class="o-flexbox u-align-items--center u-gap--small u-flex-wrap--wrap"
                >
                  <small class="c-navigation-availability-title__small">
                    Miami FL</small
                  >
                  <span>-</span
                  ><span class="u-font-size--small"
                    >2 Apr 2024 - 30 Apr 2024</span
                  >
                </div>
                <b
                  class="c-navigation-availability-title__medium c-navigation-availability-title--ellipsis"
                >
                  Clarion Inn &amp; Suites Miami International Airport
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="accommodation-detail:c-mobile-navigation"
        class="c-mobile-navigation c-mobile-navigation--accommodation-detail"
      >
        <div
          class="c-mobile-navigation-bar c-mobile-navigation-bar--top u-display--block u-display--none@md"
          style="margin-top: 0px; visibility: hidden"
        >
          <div class="c-mobile-navigation-content-wrapper">
            <div class="c-navigation-availability">
              <div class="c-navigation-availability__text">
                <div class="c-navigation-availability-title">
                  <small class="c-navigation-availability-title__small">
                    Miami FL</small
                  ><b
                    class="c-navigation-availability-title__medium c-navigation-availability-title--ellipsis"
                  >
                    Clarion Inn &amp; Suites Miami International Airport
                  </b>
                </div>
              </div>
              <div
                class="c-navigation-availability__edit"
                data-toggle="modal"
                data-target="#composeModal"
              >
                <i class="fa-regular fa-search"></i>
              </div>
            </div>
          </div>
        </div>
        <div
          class="c-mobile-navigation-bar c-mobile-navigation-bar--bottom u-display--block u-display--none@md"
        >
          <div class="c-mobile-navigation-content-wrapper">
            <div
              id="accommodation-detail:mobileFiltersPanel"
              class="c-navigation-availability__button-group dev-filterLoader"
            >
              <!-- <div class="c-navigation-availability__button">
                <a
                  class="c-button u-min-width--auto bdr-clr--brand u-1/1 ux-open-filters u-font-size--small u-font-size--default@sm"
                  onclick="openFiltersTab()"
                  ><span>Filters</span
                  ><i class="fa-regular fa-sliders-h ml-10"></i
                ></a>
              </div> -->
              <div class="c-navigation-availability__button">
                <div
                  class="c-button bg-clr--brand u-1/1 u-font-size--small u-font-size--default@sm"
                  :class="{ 'mb-btn--disabled': loading }"
                  @click="onMobileBookClick"
                >
                  <template v-if="loading">&nbsp;</template>
                  <template v-else-if="step === 3 && remaining > 0">
                    <i class="fa-regular fa-clock"></i>
                    <span class="mb-timer" :class="{ 'mb-timer--warn': remaining <= 60 }">{{ timerFormatted }}</span>
                  </template>
                  <template v-else-if="selectedUnit">
                    <span class="mb-price">${{ summaryCost }}</span>
                    <span class="mb-sep">&middot;</span>
                    <span>{{ $func.parseIso("book") }}</span>
                  </template>
                  <template v-else>
                    {{ $func.parseIso("selectReservation") }}
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="o-block__item o-box u-display--none@sm bg-clr--lightest-gray">
        <a href="/" data-toggle="modal" data-target="#composeModal"
          ><div
            class="o-box--small o-flexbox o-flexbox--generic-row u-align-items--center u-font-size--small bg-clr--white"
          >
            <div class="o-flexbox o-group">
              <div class="o-group">
                <i class="fa-regular fa-calendar-lines"></i
                ><span
                  >{{ week.ResortCountry }}, {{ week.ResortCity }},
                  {{ week.CheckInDate }} - {{ week.CheckOutDate }}</span
                >
              </div>
              <!-- <div class="o-group">
                <i class="fa-regular fa-user-friends"></i><span>2 Adults </span>
              </div> -->
            </div>
            <i class="fa-regular fa-search"></i></div
        ></a>
      </div>
      <div class="o-container o-container--large resort-progress-host">
        <div class="resort-progress">
          <div class="progress">
            <div class="progress-inner">
              <div :class="['step', { done: step >= 1 }]">
                <div class="step-circle">&#10003;</div>
                <div><div class="step-label">{{ $func.parseIso("stepSearch") }}</div></div>
              </div>
              <div :class="['step-line', { done: step >= 2 }]"></div>
              <div :class="['step', { active: step === 2, done: step >= 3, pending: step < 2 }]">
                <div class="step-circle">2</div>
                <div><div class="step-label">{{ $func.parseIso("stepSelectUnit") }}</div></div>
              </div>
              <div :class="['step-line', { done: step >= 3 }]"></div>
              <div :class="['step', { active: step === 3, done: step >= 4, pending: step < 3 }]">
                <div class="step-circle">3</div>
                <div><div class="step-label">{{ $func.parseIso("stepContacts") }}</div></div>
              </div>
              <div :class="['step-line', { done: step >= 4 }]"></div>
              <div :class="['step', { active: step === 4, pending: step < 4 }]">
                <div class="step-circle">4</div>
                <div><div class="step-label">{{ $func.parseIso("stepConfirmation") }}</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="resort-detail-wrap o-container o-container--large">
        <div v-if="loading" class="resort-skeleton o-layout resort-cols-wrap">
          <div class="o-layout__item u-12/12 u-9/12@md resort-content-col">
            <div class="sk sk-img-grid"></div>
            <div class="sk sk-line sk-line--lg" style="width: 55%"></div>
            <div class="sk sk-line sk-line--md" style="width: 40%"></div>
            <div class="sk sk-line" style="width: 92%"></div>
            <div class="sk sk-line" style="width: 88%"></div>
            <div class="sk sk-line" style="width: 80%"></div>
            <div class="sk sk-line" style="width: 45%"></div>
            <div class="sk-amen-grid">
              <div class="sk sk-amen" v-for="n in 12" :key="`a${n}`"></div>
            </div>
            <div class="sk sk-table-row" v-for="n in 3" :key="`t${n}`"></div>
          </div>
          <div class="o-layout__item u-12/12 u-3/12@md resort-summary-col u-display--none u-display--block@md">
            <div class="summary-card">
              <div class="sk sk-sc-img"></div>
              <div class="sc-body">
                <div class="sk sk-line sk-line--lg" style="width: 80%"></div>
                <div class="sk sk-line sk-line--sm" style="width: 55%"></div>
                <div class="sk sk-sc-row" v-for="n in 4" :key="`r${n}`"></div>
                <div class="sk sk-book-btn"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="o-layout resort-cols-wrap">
        <div v-if="step === 2" class="o-layout__item u-12/12 u-9/12@md resort-content-col">
        <div class="o-block__item u-position--relative">
          <div id="image-grid-component">
            <div
              class="c-image-grid c-image-grid--desktop o-flexbox o-flexbox--generic-row u-display--none u-display--flex@md"
            >
              <div
                class="u-1/1 u-2/4@md u-display--none u-display--block@md c-image-grid__column"
              >
                <div
                  id="dev-classification-tag-0"
                  class="dev-classification-tag"
                ></div>
                <a
                  class="fancybox fancybox_hotel_image"
                  data-fancybox="photo-gallery"
                  data-caption=""
                  data-index="0"
                  tabindex="0"
                >
                  <img
                    :src="getImg(0)"
                    data-index="0"
                    loading="lazy"
                    alt="Img"
                    style=""
                    class="lazy-img u-image-object--cover u-image-object--full u-border-radius--big loaded"
                    data-ll-status="loaded"
                    width=""
                    height=""
                  />
                </a>
              </div>
              <div
                class="u-1/1 u-1/4@md u-display--none u-display--block@md c-image-grid__column"
              >
                <div class="o-flexbox o-flexbox--generic-column u-height--full">
                  <div class="u-flex--11 u-position--relative mb-10">
                    <div
                      id="dev-classification-tag-1"
                      class="dev-classification-tag"
                    ></div>
                    <a
                      class="o-position o-position--top o-position--bottom u-1/1 fancybox fancybox_hotel_image"
                      data-fancybox="photo-gallery"
                      data-caption=""
                      data-index="1"
                      tabindex="1"
                    >
                      <img
                        :src="getImg(1)"
                        data-index="1"
                        loading="lazy"
                        alt="Img"
                        width=""
                        height=""
                        style=""
                        class="lazy-img u-image-object--cover u-image-object--full u-border-radius--big loaded"
                        data-ll-status="loaded"
                      />
                    </a>
                  </div>
                  <div class="u-flex--21 u-position--relative">
                    <div
                      id="dev-classification-tag-2"
                      class="dev-classification-tag"
                    ></div>
                    <a
                      class="o-position o-position--top o-position--bottom u-1/1 fancybox fancybox_hotel_image"
                      data-fancybox="photo-gallery"
                      data-caption=""
                      data-index="2"
                      tabindex="2"
                    >
                      <img
                        :src="getImg(2)"
                        data-index="2"
                        loading="lazy"
                        alt="Img3"
                        width=""
                        height=""
                        style=""
                        class="lazy-img u-image-object--cover u-image-object--full u-border-radius--big loaded"
                        data-ll-status="loaded"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div class="u-1/1 u-1/4@md c-image-grid__column">
                <div class="o-flexbox o-flexbox--generic-column u-height--full">
                  <div
                    class="u-flex--21 u-position--relative mb-10 u-display--none u-display--block@md"
                  >
                    <div class="mapa u-position--relative u-height--full">
                      <GoogleMap
                        v-if="week"
                        :lat="
                          week && week.GPS_Lat ? parseFloat(week.GPS_Lat) : 0
                        "
                        :lon="
                          week && week.GPS_Long ? parseFloat(week.GPS_Long) : 0
                        "
                        :resortName="week.ResortName"
                      />
                    </div>
                  </div>
                  <div class="u-flex--11 u-position--relative u-1/1">
                    <div
                      style="background-color: rgba(0, 0, 0, 0.5)"
                      class="u-display--none u-display--flex@md u-justify-content--center u-align-items--center o-position o-position--bottom o-position--right u-font-size--small u-border-radius--big u-zindex--4 o-group--small u-pointer-events--none u-1/1 u-height--full"
                      @click="openGallery"
                    >
                      <span
                        class="o-group--small clr--white u-font-size--default"
                        ><i class="fa-regular fa-images"></i
                        ><span>{{
                          `${getTotalImg()} ${$func.parseIso("morePictures")}`
                        }}</span></span
                      >
                    </div>
                    <div
                      class="o-position o-position--top o-position--bottom u-1/1 u-overflow--hidden"
                    >
                      <div
                        class="c-fit-carousel owl-carousel dev-image-grid u-height--full owl-loaded owl-carousel--no-transition"
                        id="grid-more-images"
                      >
                        <div class="owl-stage-outer">
                          <div
                            class="owl-stage"
                            style="
                              transform: translate3d(0px, 0px, 0px);
                              transition: all 0s ease 0s;
                              width: 8050px;
                            "
                          >
                            <div class="owl-item active" style="width: 350px">
                              <a
                                class="c-fit-carousel__item item fancybox fancybox_hotel_image"
                                data-fancybox="photo-gallery"
                                data-caption=""
                                data-index="4"
                                tabindex="4"
                                @click="openGallery"
                                style="cursor: pointer"
                              >
                                <img
                                  :src="getImg(3)"
                                  data-index="4"
                                  loading="lazy"
                                  alt="Img4"
                                  width=""
                                  height=""
                                  style=""
                                  class="lazy-img u-image-object--cover u-image-object--full u-border-radius--big loaded"
                                  data-ll-status="loaded"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          class="c-fit-carousel__nav o-flexbox o-flexbox--generic-row u-align-items--stretch disabled"
                        >
                          <button
                            type="button"
                            role="presentation"
                            class="c-fit-carousel__button c-fit-carousel__button--prev fa-regular fa-angle-left"
                          ></button
                          ><button
                            type="button"
                            role="presentation"
                            class="c-fit-carousel__button c-fit-carousel__button--next fa-regular fa-angle-right"
                          ></button>
                        </div>
                        <div class="owl-dots disabled"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div
                class="u-1/1 u-1/4@md c-image-grid__column"
                @click="openGallery"
              >
                <div class="o-flexbox o-flexbox--generic-column u-height--100">
                  <div class="u-flex--11 u-position--relative u-1/1">
                    <div
                      style="background-color: rgba(0, 0, 0, 0.5)"
                      class="u-display--none u-display--flex@md u-justify-content--center u-align-items--center o-position o-position--bottom o-position--right u-font-size--small u-border-radius--big u-zindex--4 o-group--small u-pointer-events--none u-1/1 u-height--100"
                    >
                      <span
                        class="o-group--small clr--white u-font-size--default"
                        ><i class="fa-regular fa-images"></i
                        ><span>{{
                          `${getTotalImg()} ${$func.parseIso("morePictures")}`
                        }}</span></span
                      >
                    </div>
                    <div
                      class="o-position o-position--top o-position--bottom u-1/1 u-overflow--hidden"
                    >
                      <div
                        class="c-fit-carousel owl-carousel dev-image-grid u-height--100 owl-loaded owl-carousel--no-transition"
                        id="grid-more-images"
                      >
                        <div class="owl-stage-outer">
                          <div
                            class="owl-stage"
                            style="
                              transform: translate3d(0px, 0px, 0px);
                              transition: all 0s ease 0s;
                              width: 19600px;
                            "
                          >
                            <div class="owl-item active" style="width: 350px">
                              <a
                                class="c-fit-carousel__item item fancybox fancybox_hotel_image"
                                data-fancybox="photo-gallery"
                                data-caption=""
                                data-index="4"
                                tabindex="4"
                                style="cursor: pointer"
                              >
                                <img
                                  :src="getImg(3)"
                                  data-index="4"
                                  loading="lazy"
                                  alt="Img4"
                                  class="lazy-img img-fit-cover u-border-radius--big loaded"
                                  data-ll-status="loaded"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          class="c-fit-carousel__nav o-flexbox o-flexbox--generic-row u-align-items--stretch disabled"
                        >
                          <button
                            type="button"
                            role="presentation"
                            class="c-fit-carousel__button c-fit-carousel__button--prev fa-regular fa-angle-left"
                          ></button
                          ><button
                            type="button"
                            role="presentation"
                            class="c-fit-carousel__button c-fit-carousel__button--next fa-regular fa-angle-right"
                          ></button>
                        </div>
                        <div class="owl-dots disabled"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
            <div
              class="c-image-grid c-image-grid--mobile o-flexbox o-flexbox--generic-row u-display--flex u-display--none@md"
            >
              <div
                class="c-fit-carousel dev-image-grid owl-carousel u-height--100 owl-loaded owl-carousel--no-transition"
              >
                <div class="owl-stage-outer">
                  <div
                    class="owl-stage"
                    style="
                      transform: translate3d(0px, 0px, 0px);
                      transition: all 0s ease 0s;
                      width: 0px;
                    "
                  >
                    <div class="owl-item active" style="width: 0px">
                      <a
                        class="c-fit-carousel__item item fancybox fancybox_hotel_image"
                        data-fancybox="photo-gallery-mobile"
                        data-caption=""
                        data-index="0"
                        tabindex="0"
                        @click="openGallery"
                      >
                        <img
                          :src="getImg(0)"
                          data-index="0"
                          data-error-src="https://booking.vacancyrewards.com/javax.faces.resource/images/no-photo-XS.jpg"
                          loading="lazy"
                          alt="img"
                          :style="`width: ${widthWindow - 40}px; ${
                            (timeBool && 'opacity: 0.5;') || ''
                          }`"
                          class="lazy-img img-fit-cover u-border-radius--big"
                          data-ll-status="native"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  class="c-fit-carousel__nav o-flexbox o-flexbox--generic-row u-align-items--stretch disabled"
                >
                  <button
                    type="button"
                    role="presentation"
                    class="c-fit-carousel__button c-fit-carousel__button--prev fa-regular fa-angle-left"
                  ></button
                  ><button
                    type="button"
                    role="presentation"
                    class="c-fit-carousel__button c-fit-carousel__button--next fa-regular fa-angle-right"
                  ></button>
                </div>
                <div class="owl-dots disabled"></div>
              </div>
            </div>
          </div>
        </div>

        <br>
        <div class="resort-title-block o-block__item">
          <div class="o-block__item">
            <!-- <div class="mb-10">
              <b
                class="clr--brand u-font-size--small u-font-size--default@sm u-display--block u-line-height--1"
              ><a>{{
                `${getText("ResortCity")}, ${getText("ResortState")}`
              }}</a></b
              >
            </div> -->
            <div class="o-block__item">
              <div
                class="u-display--inline-flex@sm u-align-items--center u-flex-wrap--wrap o-group--small"
              >
                <div
                  id="sheethotelName"
                  class="u-display--inline-block o-group--small"
                >
                  <h1
                    class="u-font-size--big u-font-size--huge@sm u-font-weight--700 u-line-height--1 m-0 hotel-name"
                  >
                    {{ getText("ResortName") }}
                    <span
                      class="c-hotel-status__category u-vertical-align--middle u-white-space--nowrap c-hotel-status--sm"
                      style="visibility: hidden"
                    ><i class="fa-solid fa-star c-hotel-status__star"></i
                    ><i class="fa-solid fa-star c-hotel-status__star"></i
                    ><i
                      class="fa-solid fa-star c-hotel-status__star hidden"
                    ></i
                    ><i
                      class="fa-solid fa-star c-hotel-status__star hidden"
                    ></i
                    ><i
                      class="fa-solid fa-star c-hotel-status__star hidden"
                    ></i
                    ><i
                      class="fa-solid fa-star c-hotel-status__star hidden"
                    ></i
                  ></span>
                  </h1>
                </div>
              </div>
              <a class="u-display--block js-open-hotel-map"
              ><u class="u-display--block mt-5" style="text-decoration: none;"
                >{{
                  `${getText("ResortAddress1")} ${getText(
                    "ResortAddress2"
                  )} ${getText("ResortAddress3")}`
                }}
              </u>
              <ul>
                {{ `${getText("ResortCity")}, ${getText("ResortState")}, ${getText("ResortCountry")}` }}
              </ul></a
              >
            </div>
          </div>
        </div>

        <!-- <div
          class="bg-clr--white o-position--sticky o-position--top c-tab-buttons u-zindex--8 mt-10 u-transition"
          style="top: 0px"
        >
          <div class="o-container o-container--large">
            <div
              id="accommodationSectionPanel"
              class="o-layout o-layout--stretch u-flex-wrap--nowrap u-text-align--center u-text-transform--uppercase dev-accommodationSectionPanel u-border--bottom bdr-clr--lighter-gray"
            >
              <div class="o-layout__item u-1/1">
                <a
                  class="c-tab-button c-tab-button--large u-1/1 dev-go-to-section-accommodation"
                  data-scroll-tab="hotel"
                >
                  {{ $func.parseIso("aboutProperty") }}
                </a>
              </div>
              <div class="o-layout__item u-1/1">
                <a
                  class="c-tab-button c-tab-button--large u-1/1 dev-go-to-section-facilities"
                  data-scroll-tab="facilities"
                >
                  {{ $func.parseIso("services") }}
                </a>
              </div>
              <div class="o-layout__item u-1/1" v-if="units && units.length">
                <a
                  class="c-tab-button c-tab-button--large u-1/1 dev-go-to-section-units"
                  data-scroll-tab="units"
                >
                  {{ $func.parseIso("availableUnits") }}
                </a>
              </div>
            </div>
          </div>
        </div> -->

        <div class="o-block o-block--big mt-20">
          <div
            id="section-accommodation"
            data-scroll-section="hotel"
            class="o-block__item scroll-section"
          >
            <div
              class="o-flexbox o-flexbox--generic-column o-flexbox--generic-row@md u-align-items--start u-flex-direction--column-reverse u-flex-direction--row@md u-gap--big u-gap--default@md u-gap--bigger@lg"
            >
              <div class="u-1/1">
                <h2 class="c-title--main u-font-weight--700 m-0">
                  {{ $func.parseIso("aboutProperty") }}
                </h2>
                <div
                  id="descriptionHotelPanel"
                  class="ui-outputpanel ui-widget"
                >
                  <div class="o-box--middle--vertical descripcion dev-de">
                    <div
                      id="read-more--j_id_fm"
                      class="c-read-more c-read-more--collapsed c-read-more--collapse-active"
                    >
                      <div
                        class="js-readmore-container u-overflow--hidden m-0 c-read-more__line-height--default"
                        style="
                          line-height: 1.5;
                          font-size: 14px;
                          max-height: 105px;
                        "
                      >
                        <div class="js-readmore-element">
                          {{ getDescription() }}
                        </div>
                      </div>
                      <div
                        class="c-read-more__link c-inline-link pt-5 clr--dark-gray"
                      >
                        <!-- <div
                          role="button"
                          tabindex="0"
                          class="c-read-more__link--more u-text-decoration--underline u-cursor--pointer"
                        >
                          <b>Read more</b>
                        </div>
                        <div
                          role="button"
                          tabindex="0"
                          class="c-read-more__link--less u-text-decoration--underline u-cursor--pointer"
                        >
                          <b>Read less</b>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="section-facilities"
            data-scroll-section="facilities"
            class="o-block__item o-block scroll-section dev-section-facilities"
          >
            <div class="o-block__item">
              <h2 class="c-title--main u-font-weight--bold m-0 pb-5">
                {{ $func.parseIso("services") }}
              </h2>
            </div>
            <div
              class="o-layout o-layout--stretch o-layout--gutter-small o-layout--gutter-default@md o-layout--fix u-justify-content--start mb-10 mb-0@md"
            >
<div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
                v-for="(item, idx) in displayAmenities"
                :key="idx"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    :class="[amenIcon(item[iso] && item[iso].name), 'u-font-size--bigger u-font-size--huge@xs']"
                  ></i>
                  <span class="u-font-size--small">{{
                    (item[iso] && item[iso].name) || "n/a"
                  }}</span>
                </div>
              </div>
              <!-- <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-language u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Multilingual staff</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-dumbbell u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Fitness room</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="ico-tc-WIFI u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Wi-fi</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa fa-taxi u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Airport Shuttle</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-dog-leashed u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Service Animal allowed</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-vault u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Hotel safe</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-grill u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">BBQ Facilities</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa fa-wheelchair u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Wheelchair-accessible</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-bag-shopping u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Shop</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-elevator u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Elevator</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-dollar-sign u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Business centre</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-handshake u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Meeting room</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-mug-hot u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small"
                    >Tea and coffee making facilities</span
                  >
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-newspaper u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Newspapers</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-user-hair-buns u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Hairdressing salon</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-fork-knife u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Restaurant</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-gamepad u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Game room</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-square-parking u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Accessible parking</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-suitcase-rolling u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Luggage room</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-flower-daffodil u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Garden</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-bell-concierge u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">24-hour reception</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-microwave u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Microwave</span>
                </div>
              </div>
              <div
                class="o-layout__item u-1/2 u-1/3@xs u-1/4@sm u-1/5@md u-1/6@xl mb-10 mb-20@md"
              >
                <div
                  class="o-flexbox u-gap--tiny u-gap--small@sm u-align-items--center o-box--default--vertical o-box--middle--horizontal u-border--full bdr-clr--lighter-gray u-border-radius u-line-height--11"
                >
                  <i
                    class="fa-regular fa-ban u-font-size--bigger u-font-size--huge@xs"
                  ></i>
                  <span class="u-font-size--small">Pets not allowed</span>
                </div>
              </div> -->
            </div>
            <!-- <div class="u-line-height--1">
              <span
                data-toggle="collapse"
                data-target="#otherservices"
                class="c-inline-link c-inline-link--underline u-cursor--pointer u-text-transform--uppercase u-font-weight--600 u-font-size--small u-collapse-turn-arrow collapsed"
              >
                Other services
                <i
                  class="fa-regular fa-chevron-down u-collapse-turn-arrow__icon"
                ></i
              ></span>
            </div> -->
          </div>

          <!-- <ResortMoreItems /> -->

          <div
            id="section-units"
            data-scroll-section="units"
            class="o-block__item o-block scroll-section"
            v-if="units && units.length"
          >
            <div class="o-block__item">
              <div class="nr-banner">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"></path>
                  <line x1="12" y1="9" x2="12" y2="13"></line>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
                <div><strong>{{ $func.parseIso("nonRefundableBanner") }}</strong> {{ $func.parseIso("nonRefundableBannerDetail") }}</div>
              </div>

              <div class="sec-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="7" width="18" height="13" rx="2"></rect>
                  <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"></path>
                </svg>
                {{ $func.parseIso("selectAUnit") }} &middot; {{ formatDate(searchWeek.checkIn) }}&ndash;{{ formatDate(searchWeek.checkOut) }}
              </div>

              <div class="units-table-wrap">
                <table class="units-table">
                  <thead>
                    <tr>
                      <th>{{ $func.parseIso("unit") }}</th>
                      <th>{{ $func.parseIso("checkInLabel") }}</th>
                      <th>{{ $func.parseIso("checkOutLabel") }}</th>
                      <th>{{ $func.parseIso("weekType") }}</th>
                      <th>{{ $func.parseIso("kitchen") }}</th>
                      <th>{{ $func.parseIso("maxGuests") }}</th>
                      <th>{{ $func.parseIso("totalPrice") }}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(u, i) in sortedUnits"
                      :key="u._id || u.InventoryID || i"
                      :class="{ 'is-selected': selectedUnitIndex === i }"
                      @click="selectUnit(u, i)"
                    >
                      <td><strong>{{ u.UnitType }}</strong></td>
                      <td>{{ formatDate(u.CheckInDate) }}</td>
                      <td>{{ formatDate(u.CheckOutDate) }}</td>
                      <td><span class="wt-pill" :class="wtPillClass(u.InvTypeInDetail)">{{ u.InvTypeInDetail }}</span></td>
                      <td>{{ u.KitchenType }}</td>
                      <td>{{ u.MaxOccupancy }} {{ $func.parseIso("guests") }}</td>
                      <td>
                        <div class="unit-price">${{ u.Cost }}</div>
                        <div class="unit-ppn">${{ perNight(u.Cost) }} {{ $func.parseIso("perNight") }}<span v-if="isFixedPrice(u.InvTypeInDetail)"> &middot; {{ $func.parseIso("fixedPrice") }}</span></div>
                      </td>
                      <td>
                        <button class="book-btn" @click.stop="selectUnit(u, i)">
                          {{ $func.parseIso("selectUnit") }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div id="destinationInformationPanel" class="o-block o-block--big">
            <!-- <div
              class="u-position--relative scroll-section dev-destination-information"
              data-scroll-section="destination"
              style="height: 350px"
            >
              <picture
                ><source
                  media="(min-width: 1200px)"
                  data-srcset="https://cdn5.travelconline.com/unsafe/fit-in/2000x0/filters:quality(75):format(webp)/https%3A%2F%2Fstatic.travelconline.com%2Fimagenes%2FcS2HaBmGX1vB-SA7I13LF5WkylTt.jpeg"
                  srcset="
                    https://cdn5.travelconline.com/unsafe/fit-in/2000x0/filters:quality(75):format(webp)/https%3A%2F%2Fstatic.travelconline.com%2Fimagenes%2FcS2HaBmGX1vB-SA7I13LF5WkylTt.jpeg
                  " />
                <source
                  media="(min-width: 768px)"
                  data-srcset="https://cdn5.travelconline.com/unsafe/fit-in/1200x0/filters:quality(75):format(webp)/https%3A%2F%2Fstatic.travelconline.com%2Fimagenes%2FcS2HaBmGX1vB-SA7I13LF5WkylTt.jpeg"
                  srcset="
                    https://cdn5.travelconline.com/unsafe/fit-in/1200x0/filters:quality(75):format(webp)/https%3A%2F%2Fstatic.travelconline.com%2Fimagenes%2FcS2HaBmGX1vB-SA7I13LF5WkylTt.jpeg
                  " />
                <img
                  data-src="https://cdn5.travelconline.com/unsafe/fit-in/768x0/filters:quality(75):format(webp)/https%3A%2F%2Fstatic.travelconline.com%2Fimagenes%2FcS2HaBmGX1vB-SA7I13LF5WkylTt.jpeg"
                  src="https://cdn5.travelconline.com/unsafe/fit-in/768x0/filters:quality(75):format(webp)/https%3A%2F%2Fstatic.travelconline.com%2Fimagenes%2FcS2HaBmGX1vB-SA7I13LF5WkylTt.jpeg"
                  data-error-src="/javax.faces.resource/images/no-photo-XS.jpg"
                  alt=""
                  style=""
                  class="img-fit-cover u-border-radius--big lazy-img loaded"
                  loading="lazy"
                  data-ll-status="loaded"
              /></picture>
            </div> -->
            <!-- <div class="o-block__item">
              <div
                class="o-box pt-40@md pb-30@md pr-40@md pl-40@md bg-clr--lightest-gray u-border-radius--big"
              >
                <div
                  class="o-layout@md o-layout--gutter-big@md o-layout--gutter-huge@lg pt-20"
                >
                  <div class="o-layout__item u-1/1 u-3/12@lg pb-20">
                    <h2
                      class="u-font-size--bigger u-font-weight--700 m-0 pb-10 pb-20@lg"
                    >
                      {{ $func.parseIso("policies") }}
                    </h2>
                  </div>
                  <div class="o-layout__item u-1/1 u-9/12@lg">
                    <div class="o-layout@sm o-layout--gutter-default@sm">
                      <div class="o-layout__item u-1/1 u-1/2@sm pb-30">
                        <h3 class="u-font-size--middle u-font-weight--700 mt-0">
                          Check-in
                        </h3>
                        <ul class="m-0">
                          <li class="pb-5">
                            <span>Checkin from 3:00 PM to anytime</span>
                          </li>
                          <li class="pb-5">
                            <span>Minimum age for check-in: 21 years old</span>
                          </li>
                        </ul>
                      </div>
                      <div class="o-layout__item u-1/1 u-1/2@sm pb-30">
                        <h3 class="u-font-size--middle u-font-weight--700 mt-0">
                          Check-out
                        </h3>
                        <span class="u-display--block"
                          >Checkout before 11:00 AM
                        </span>
                      </div>
                      <div class="o-layout__item u-1/1 pb-30">
                        <h3 class="u-font-size--middle u-font-weight--700 mt-0">
                          Special check-in instructions
                        </h3>
                        <span class="u-display--block"
                          >This property offers transfers from the cruise
                          terminal (surcharges may apply). Guests must contact
                          the property with arrival details before travel, using
                          the contact information on the booking confirmation.
                          Front desk staff will greet guests on arrival.</span
                        >
                      </div>
                      <div class="o-layout__item u-1/1 pb-30 u-allow-list">
                        <h3 class="u-font-size--middle u-font-weight--700 mt-0">
                          Pets
                        </h3>
                        <span class="u-display--block pb-5">
                          Service animals are allowed
                        </span>
                        <span class="u-display--block pb-5">
                          Service animals are exempt from fees/restrictions
                        </span>
                        <span class="u-display--block pb-5">
                          Pets not allowed
                        </span>
                        <span class="u-display--block"></span>
                      </div>
                      <div class="o-layout__item u-1/1 pb-30">
                        <h3 class="u-font-size--middle u-font-weight--700 mt-0">
                          Children and extra beds
                        </h3>
                        <span class="u-display--block"></span
                        ><span class="u-display--block"
                          >No cribs (infant beds) available</span
                        ><span class="u-display--block"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <div class="o-block__item">
              <div
                class="o-box pt-40@md pb-40@md pr-40@md pl-40@md bg-clr--lightest-gray u-border-radius--big"
              >
                <div
                  class="o-layout@md o-layout--gutter-big@md o-layout--gutter-huge@lg pt-20 pb-20"
                >
                  <div class="o-layout__item u-1/1 u-3/12@lg pb-20">
                    <h2
                      class="u-font-size--bigger u-font-weight--700 m-0 pb-10 pb-20@lg"
                    >
                      {{ $func.parseIso("importantInformation") }}
                    </h2>
                  </div>
                  <div class="o-layout__item u-1/1 u-9/12@lg">
                    <div
                      class="o-block o-block--big u-allow-list u-allow-list--space-between"
                    >
                      <div class="o-block__item">
                        <h3
                          class="u-font-size--middle u-font-weight--700 m-0 pb-20"
                        >
                          Fees
                        </h3>
                        <p>
                          You'll be asked to pay the following charges at the
                          property:
                        </p>
                        <ul>
                          <li>Deposit: USD 100 per accommodation, per stay</li>
                          <li>Breakage deposit: USD 100 per stay</li>
                        </ul>
                        <p>
                          We have included all charges provided to us by the
                          property.
                        </p>
                      </div>
                      <div class="o-block__item">
                        <h3
                          class="u-font-size--middle u-font-weight--700 m-0 pb-20"
                        >
                          Optional fees
                        </h3>
                        <ul>
                          <li>
                            Fee for cooked-to-order breakfast: approximately USD
                            6–12 for adults, and USD 6–12 for children
                          </li>
                          <li>
                            Early check-in fee: USD 25.00 (subject to
                            availability)
                          </li>
                          <li>
                            Late check-out fee: USD 25.00 (subject to
                            availability)
                          </li>
                        </ul>
                        <p>
                          The above list may not be comprehensive. Fees and
                          deposits may not include tax and are subject to
                          change.
                        </p>
                      </div>
                      <div class="o-block__item">
                        <h3
                          class="u-font-size--middle u-font-weight--700 m-0 pb-20"
                        >
                          Other details
                        </h3>
                        <ul>
                          <li>
                            Extra-person charges may apply and vary depending on
                            property policy
                          </li>
                          <li>
                            Government-issued photo identification and a credit
                            card may be required at check-in for incidental
                            charges
                          </li>
                          <li>
                            Special requests are subject to availability upon
                            check-in and may incur additional charges; special
                            requests cannot be guaranteed
                          </li>
                          <li>
                            The name on the credit card used at check-in to pay
                            for incidentals must be the primary name on the
                            guestroom reservation
                          </li>
                          <li>
                            This property accepts credit cards, debit cards, and
                            cash
                          </li>
                          <li>
                            Safety features at this property include a carbon
                            monoxide detector, a fire extinguisher, a smoke
                            detector, a security system, a first aid kit, and
                            window guards
                          </li>
                          <li>
                            This property affirms that it follows the cleaning
                            and disinfection practices of Commitment to Clean
                            (Choice)
                          </li>
                          <li>
                            Please note that cultural norms and guest policies
                            may differ by country and by property; the policies
                            listed are provided by the property
                          </li>
                        </ul>
                        <ul>
                          <li>
                            Up to 3 children 18 years old and younger stay free
                            when occupying the parent or guardian's room, using
                            existing bedding.
                          </li>
                          <li>
                            The property has connecting/adjoining rooms, which
                            are subject to availability and can be requested by
                            contacting the property using the number on the
                            booking confirmation.
                          </li>
                          <li>Contactless check-out is available.</li>
                          <li>
                            This property welcomes guests of all sexual
                            orientations and gender identities (LGBTQ+
                            friendly).
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        </div>
        <div v-else-if="step === 3" class="o-layout__item u-12/12 u-9/12@md resort-content-col traveler-step-wrap">
          <TravelerForm :week="week" :iso="iso" :numberRef="numberRef" @back="goBackToResort" @hold-success="onHoldSuccess" />
        </div>
        <div v-else-if="step === 4" class="o-layout__item u-12/12 u-9/12@md resort-content-col">
          <Payment
            :week="week"
            :numberRef="numberRef"
            :price="price"
            :iso="iso"
            @cancel="goToStep2"
          />
        </div>

        <div class="o-layout__item u-12/12 u-3/12@md resort-summary-col u-display--none u-display--block@md">
          <SummaryCard
            :week="week"
            :selectedUnit="selectedUnit"
            :step="step"
            :remaining="remaining"
            :timerFormatted="timerFormatted"
            :msgBtn="msgBtn"
            :traveler="travelerData"
            @book="goBook"
          />
        </div>
        </div>

        <div
          id="j_id_1fp:modalHotelSocialNetworks"
          class="c-modal modalHotelSocialNetworks"
          data-size="small"
          role="dialog"
          data-closeable="true"
          tabindex="-1"
          aria-modal="true"
          data-active="false"
        >
          <div
            class="c-modal__backmask"
            onclick="$('.modalHotelSocialNetworks').modal('hide')"
          ></div>
          <div class="c-modal__wrapper">
            <div class="c-modal__container">
              <div class="c-modal__close" style="">
                <button
                  type="button"
                  class="c-modal__close-btn"
                  data-dismiss="modal"
                >
                  <span
                    class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
                  >
                    Close
                    <i
                      class="fa-solid fa-caret-right u-font-size--default"
                    ></i></span
                  ><i class="u-display--block fa-regular fa-close"></i>
                </button>
              </div>
              <div class="c-modal__body">
                <div
                  class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
                ></div>
                <div class="o-block hidden-print u-text-align--center">
                  <div class="o-block__item">
                    <i
                      class="fa-regular fa-share-alt clr--success u-font-size--jumbo"
                    ></i>
                    <div class="mt-10 clr--light-gray">Share</div>
                    <h2 class="u-font-size--big mt-5 mb-10"><b></b></h2>
                  </div>
                  <div class="o-block__item">
                    <div class="o-layout o-layout--center">
                      <div class="o-layout__item u-4/5@xs">
                        <ul>
                          <li role="presentation">
                            <a
                              href="#share-twitter"
                              class="c-button u-1/1 u-justify-content--between mb-10 fakeLink share-social-btn"
                              tabindex="-1"
                              role="menuitem"
                              title="Twitter"
                              data-share-url="https://twitter.com/intent/tweet?url=https%3A%2F%2Fbooking.vacancyrewards.com%2Fen%2Faccommodation%2F72651%2Fclarion-inn-suites-miami-international-airport&amp;text=Clarion+Inn+%26+Suites+Miami+International+Airport&amp;via=**TWITTER_ACCOUNT_NAME_MISSING**&amp;related=**TWITTER_ACCOUNT_NAME_MISSING**"
                              ><span>Twitter</span
                              ><i class="fab fa-x-twitter clr--twitter"></i
                            ></a>
                          </li>
                          <li role="presentation">
                            <a
                              href="#share-facebook"
                              class="c-button u-1/1 u-justify-content--between mb-10 fakeLink share-social-btn"
                              tabindex="-1"
                              role="menuitem"
                              title="Facebook"
                              data-share-url="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fbooking.vacancyrewards.com%2Fen%2Faccommodation%2F72651%2Fclarion-inn-suites-miami-international-airport"
                              ><span>Facebook</span
                              ><i class="fab fa-facebook clr--facebook"></i
                            ></a>
                          </li>
                          <li role="presentation">
                            <a
                              href="https://web.whatsapp.com/send?text=https%3A%2F%2Fbooking.vacancyrewards.com%2Fen%2Faccommodation%2F72651%2Fclarion-inn-suites-miami-international-airport"
                              tabindex="-1"
                              target="_blank"
                              class="c-button u-1/1 u-justify-content--between mb-10 share-social-btn"
                              title="Whatsapp"
                              role="menuitem"
                              data-action="share/whatsapp/share"
                            >
                              <span>Whatsapp</span
                              ><i class="fab fa-whatsapp clr--whatsapp"></i
                            ></a>
                          </li>
                          <li role="presentation">
                            <a
                              href="https://telegram.me/share/url?url=https%3A%2F%2Fbooking.vacancyrewards.com%2Fen%2Faccommodation%2F72651%2Fclarion-inn-suites-miami-international-airport&amp;text=Clarion+Inn+%26+Suites+Miami+International+Airport"
                              tabindex="-1"
                              target="_blank"
                              class="c-button u-1/1 u-justify-content--between mb-10 share-social-btn"
                              title="Telegram"
                              role="menuitem"
                            >
                              <span>Telegram</span
                              ><i class="fab fa-telegram clr--telegram"></i
                            ></a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Footer :isDefault="club && false" :club="club" /> -->
    <Fancybox
      :options="{
        Carousel: {
          infinite: false,
        },
      }"
    >
      <a
        data-fancybox="gallery"
        :href="item"
        v-for="(item, idx) in getImgs()"
        :ref="`item${idx + 1}`"
        style="display: none"
      >
        <img :src="item" width="200" height="150" />
      </a>
    </Fancybox>
    <ConfirmModal
      :show="confirmModal.show"
      :title="confirmModal.title"
      :description="confirmModal.description"
      :confirmText="confirmModal.confirmText"
      :cancelText="confirmModal.cancelText"
      @confirm="onConfirm"
      @cancel="onCancel"
    />
    <Alert
      :show="alertTimeout.show"
      :title="alertTimeout.title"
      :closeAlert="alertTimeout.close"
    />
  </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ModalStripe from "./ModalStripe.vue";
import ModalStripeCheckout from "./ModalStripeCheckout.vue";
import Payment from "./Payment.vue";
import Fancybox from "../components/Fancybox.vue";
import GoogleMap from "../components/GoogleMap.vue";
import ResortMoreItems from "../components/ResortList/ResortMoreItems.vue";
import TravelerForm from "../components/TravelerForm.vue";
import ConfirmModal from "../components/ConfirmModal.vue";
import Alert from "../components/Alert.vue";
import SummaryCard from "../components/SummaryCard.vue";

import {
  getSearchWeekObject,
  getTokenTC,
  setSearchWeekObject,
  getBookingTimer,
  setBookingTimer,
  removeBookingTimer,
  getSelectedUnit,
  setSelectedUnit,
  removeSelectedUnit,
  getSesion,
  setHoldNumberRef,
  getHoldNumberRef,
  removeHoldNumberRef,
} from "../utils/sesions";

export default {
  components: {
    Header,
    Footer,
    ModalStripe,
    ModalStripeCheckout,
    Payment,
    Fancybox,
    GoogleMap,
    ResortMoreItems,
    TravelerForm,
    ConfirmModal,
    Alert,
    SummaryCard,
  },
  // props: ["items"],
  data() {
    return {
      weekId: null,
      weekInventoryId: null,
      week: {},
      loading: true,
      token: null,
      club: null,
      iso: null,
      member: null,
      numberRef: null,
      clientSecret: null,
      price: null,
      count: 5,
      msgBtn: null,
      timeBool: false,
      widthWindow: 300,
      selectedUnit: null,
      selectedUnitIndex: null,
      units: [],
      step: 2,
      travelerData: null,
      bookingDeadline: null,
      remaining: 0,
      timerId: null,
      confirmModal: {
        show: false,
        title: "",
        description: "",
        confirmText: "",
        cancelText: "",
        action: null,
      },
      alertTimeout: {
        show: false,
        title: null,
        close: null,
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    this.stopTimer();
  },
  async created() {
    // await this.checkSesion();
    await this.checkParams();
    await this.listWeek();
    // this.loading = false;

    this.restoreBookingState();

    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
      this.$forceUpdate();
    });

    this.$bus.on("confirm-pay", () => {
      this.showModalConfirm();
      this.$forceUpdate();
    });

    // setInterval(
    //   (__this) => {
    //     __this.timeBool = !__this.timeBool;
    //   },
    //   1500,
    //   this
    // );
    // console.log('window.innerWidth', window.innerWidth)
    this.widthWindow = window.innerWidth;
  },
  computed: {
    searchWeek() {
      return getSearchWeekObject() || {};
    },
    sortedUnits() {
      return [...this.units].sort(
        (a, b) => new Date(a.CheckInDate) - new Date(b.CheckInDate)
      );
    },
    displayAmenities() {
      if (!this.week || !this.week.resort || !this.week.resort.amenities)
        return [];
      const iso = localStorage.getItem("iso") || this.iso || "en";
      return this.week.resort.amenities.filter((a) => {
        const prox = a[iso] && a[iso].proximity;
        return prox === "Onsite" || prox === "Yes";
      });
    },
    timerFormatted() {
      const s = Math.max(0, this.remaining);
      const m = Math.floor(s / 60);
      const sec = s % 60;
      return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
    },
    summaryCost() {
      return this.selectedUnit ? this.selectedUnit.Cost : 0;
    },
  },
  methods: {
    amenIcon(name) {
      const n = (name || "").toLowerCase();
      const map = [
        [/pool|swimming/, "fa-regular fa-water-ladder"],
        [/hot tub/, "fa-regular fa-hot-tub-person"],
        [/spa/, "fa-regular fa-spa"],
        [/fitness/, "fa-solid fa-dumbbell"],
        [/tennis/, "fa-solid fa-baseball-ball"],
        [/restaurant|bar\/lounge|bar/, "fa-regular fa-utensils"],
        [/game room/, "fa-solid fa-gamepad"],
        [/playground|children/, "fa-solid fa-child"],
        [/business center/, "fa-solid fa-briefcase"],
        [/concierge/, "fa-regular fa-bell-concierge"],
        [/golf/, "fa-solid fa-golf-ball-tee"],
        [/elevator/, "fa-solid fa-elevator"],
        [/internet|wi.?fi/, "fa-solid fa-wifi"],
        [/laundry/, "fa-solid fa-soap"],
        [/parking/, "fa-solid fa-square-parking"],
        [/atm|banking/, "fa-regular fa-money-bill"],
        [/marina/, "fa-solid fa-anchor"],
        [/movie/, "fa-solid fa-film"],
        [/nightclub/, "fa-solid fa-music"],
        [/safe/, "fa-solid fa-lock"],
        [/sauna/, "fa-regular fa-heat"],
        [/steam/, "fa-regular fa-heat"],
        [/shuttle/, "fa-solid fa-bus"],
        [/television|tv/, "fa-solid fa-tv"],
        [/wheelchair|accessible/, "fa-solid fa-wheelchair"],
        [/billiards|pool table/, "fa-solid fa-circle-dot"],
        [/car rental/, "fa-solid fa-car"],
        [/conference/, "fa-solid fa-chalkboard-user"],
        [/gift shop|newsstand/, "fa-solid fa-bag-shopping"],
        [/grocery/, "fa-solid fa-cart-shopping"],
        [/medical/, "fa-solid fa-suitcase-medical"],
        [/multilingual/, "fa-solid fa-language"],
      ];
      for (const [re, icon] of map) {
        if (re.test(n)) return icon;
      }
      return "fa-regular fa-circle-info";
    },
    async checkParams() {
      const { weekId, weekInventoryId } = this.$route.query;
      this.weekId = weekId || null;
      this.weekInventoryId = weekInventoryId || null;
    },
    async listWeek() {
      const procesarParametroQuery = (textoQuery) => {
        const decodificado = decodeURIComponent(textoQuery);
        return decodificado.replace(/ /g, "+");
      };

      if (this.weekInventoryId) {
        try {
          const searchWeek = getSearchWeekObject();
          const { data } = await this.$axios.post(
            `/week/only-inventory?isInventory=y`,
            {
              inventoryId: procesarParametroQuery(this.weekInventoryId),
              dateIn: (searchWeek && searchWeek.checkIn) || undefined,
              dateOut: (searchWeek && searchWeek.checkOut) || undefined,
            }
          );
          this.week = data.week;
          this.price = data.week.Cost;
          this.units = data.units || [];
          this.loading = false
          // console.log(this.countries);
        } catch (error) {
          console.log(error);
        }
      } else if (this.weekId) {
        try {
          const { data } = await this.$axios.get(`/week/only/${this.weekId}`);
          this.week = data.week;
          this.price = data.week.Cost;
          this.units = data.units || [];
          this.loading = false
          // console.log(this.countries);
        } catch (error) {
          console.log(error);
        }
      } else this.$router.push("/");
    },
    getText(key, firstText = "") {
      if (this.week)
        return this.week[key] ? `${firstText} ${this.week[key]}` : "";
      else return "";
    },
    formatDate(date) {
      return this.$moment(date).format("ll");
    },
    getImg(position) {
      if (this.week)
        return (
          this.week.imgs[position] ||
          "https://dicesabajio.com.mx/wp-content/uploads/2021/06/no-image.jpeg"
        );
      else
        return "https://dicesabajio.com.mx/wp-content/uploads/2021/06/no-image.jpeg";
    },
    getTotalImg() {
      if (this.week) return this.week.imgs.length;
      else return 0;
    },
    getImgs() {
      if (this.week) return this.week.imgs;
      else return [];
    },
    getDescription() {
      if (this.week && this.week.resort)
        return this.iso === "en"
          ? this.week.resort?.HighlightsEN
          : this.week.resort?.HighlightsSP;
      else return "";
    },
    async pay() {
      try {
        if (this.clientSecret) {
          this.$modal.show("pay");
        } else {
          /**
           * Reservamos
           */

          this.msgBtn = `${this.$func.parseIso("reserving")}...`;

          const payload = {
            client: {
              name: this.member.Nombre,
              lastname: this.member.ApellidoPaterno,
              email: this.member.Email || "",
              phone: this.member.Telefono || "",
              address: this.member.Direccion,
              city: this.member.Ciudad,
              state: this.member.Estado,
              zipcode: this.member.CodigoPostal,
              country: this.member.Pais,
              iso: this.member.Idioma === "EN" ? "en" : "es",
            },
            inventoryId: this.week.InventoryID,
            createdBy: "weeks",
          };

          const { data } = await this.$axios.post(`/week/hold`, {
            ...payload,
          });
          this.numberRef = data.numberRef;

          /**
           * Creamos el pago
           */

          this.msgBtn = `${this.$func.parseIso("startingStripe")}...`;

          const { data: payment } = await this.$axios.get(
            `/payment/create/payment-intent?numberRef=${this.numberRef}`
          );
          console.log("payment", payment);
          this.clientSecret = payment.clientSecret;

          await this.$forceUpdate();

          /**
           * Pasamos a Stripe
           */
          await this.$modal.show("pay");
        }
      } catch (error) {
        alert("Error al reservar o pagar");
        console.log(error);
      }
    },
    async payCheckout() {
      try {
        if (this.clientSecret) {
          this.$modal.show("pay-checkout");
        } else {
          /**
           * Reservamos
           */

          this.msgBtn = `${this.$func.parseIso("reserving")}...`;

          const payload = {
            client: {
              name: this.member.Nombre,
              lastname: this.member.ApellidoPaterno,
              email: this.member.Email || "",
              phone: this.member.Telefono || "",
              address: this.member.Direccion,
              city: this.member.Ciudad,
              state: this.member.Estado,
              zipcode: this.member.CodigoPostal,
              country: this.member.Pais,
              iso: this.member.Idioma === "EN" ? "en" : "es",
            },
            inventoryId: this.week.InventoryID,
            createdBy: "weeks",
          };

          const { data } = await this.$axios.post(`/week/hold`, {
            ...payload,
          });
          this.numberRef = data.numberRef;

          /**
           * Creamos el pago
           */

          this.msgBtn = `${this.$func.parseIso("startingStripe")}...`;

          // const { data: payment } = await this.$axios.get(
          //   `/payment/create/payment-checkout?numberRef=${this.numberRef}`
          // );
          // console.log("payment", payment);
          // this.clientSecret = `${payment.clientSecret}`;

          // await this.$forceUpdate();

          /**
           * Pasamos a Stripe
           */
          await this.$modal.show("pay-checkout");
        }
      } catch (error) {
        alert("Error al reservar o pagar");
        console.log(error);
      }
    },
    showModalConfirm() {
      this.$modal.show("confirm");
      setInterval((_this) => {
        _this.count--;
        if (_this.count <= 0) {
          clearInterval();
          _this.$router.push(`/?token=${token}`);
        }
      }, 1000),
        this;
    },
    goBook() {
      this.confirmModal = {
        show: true,
        title: this.$func.parseIso("confirmBookingTitle"),
        description: this.$func.parseIso("confirmBookingDesc"),
        confirmText: this.$func.parseIso("next"),
        cancelText: this.$func.parseIso("cancel"),
        action: "goToStep3",
      };
    },
    goBackToResort() {
      this.confirmModal = {
        show: true,
        title: this.$func.parseIso("backToResortTitle"),
        description: this.$func.parseIso("backToResortDesc"),
        confirmText: this.$func.parseIso("next"),
        cancelText: this.$func.parseIso("cancel"),
        action: "goToStep2",
      };
    },
    onConfirm() {
      const action = this.confirmModal.action;
      this.confirmModal.show = false;
      if (action === "goToStep3") this.goToStep3();
      else if (action === "goToStep2") this.goToStep2();
    },
    onCancel() {
      this.confirmModal.show = false;
    },
    onMobileBookClick() {
      if (this.loading) return;
      if (!this.selectedUnit) {
        this.scrollToUnits();
        return;
      }
      this.$modal.show("mobile-summary");
    },
    scrollToUnits() {
      const el = document.getElementById("section-units");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    onMobileBookConfirm() {
      this.$modal.hide("mobile-summary");
      this.goBook();
    },
    onHoldSuccess(traveler) {
      this.travelerData = traveler;
      this.step = 4;
      window.scrollTo(0, 0);
    },
    async goToStep3() {
      try {
        const sesionTC = getSesion();
        const loginId = sesionTC?.LoginID || null;
        const { data } = await this.$axios.post("/week/hold-fast", {
          createdBy: loginId || "weeks",
          inventoryId: this.selectedUnit.InventoryID,
          loginId: loginId,
        });
        this.numberRef = data.numberRef;
        setHoldNumberRef(this.numberRef);
      } catch (error) {
        console.log(error);
        this.openAlertTimeout("No se pudo reservar la semana. Inténtelo nuevamente.");
        return;
      }
      this.$bus.emit("footer-show", false);
      this.step = 3;
      this.bookingDeadline = Date.now() + 10 * 60 * 1000;
      this.remaining = Math.round((this.bookingDeadline - Date.now()) / 1000);
      setBookingTimer(this.bookingDeadline);
      if (this.selectedUnit) setSelectedUnit(this.selectedUnit);
      this.startTimer();
      window.scrollTo(0, 0);
    },
    goToStep2() {
      if (this.numberRef) {
        this.$axios.delete(`/week/hold-release?numberRef=${this.numberRef}`);
        removeHoldNumberRef();
        this.numberRef = null;
      }
      this.step = 2;
      this.stopTimer();
      removeBookingTimer();
      removeSelectedUnit();
      this.remaining = 0;
      this.bookingDeadline = null;
      this.travelerData = null;
      window.scrollTo(0, 0);
    },
    clearBookingState() {
      this.stopTimer();
      removeBookingTimer();
      removeSelectedUnit();
      removeHoldNumberRef();
      this.numberRef = null;
      this.remaining = 0;
      this.bookingDeadline = null;
      this.travelerData = null;
    },
    startTimer() {
      this.stopTimer();
      this.timerId = setInterval(this.tick, 1000);
    },
    stopTimer() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },
    tick() {
      if (!this.bookingDeadline) return;
      this.remaining = Math.round((this.bookingDeadline - Date.now()) / 1000);
      if (this.remaining <= 0) {
        this.remaining = 0;
        this.stopTimer();
        if (this.numberRef) {
          this.$axios.delete(`/week/hold-release?numberRef=${this.numberRef}`);
          removeHoldNumberRef();
          this.numberRef = null;
        }
        removeBookingTimer();
        removeSelectedUnit();
        this.bookingDeadline = null;
        this.step = 2;
        this.travelerData = null;
        this.openAlertTimeout();
      }
    },
    restoreBookingState() {
      const deadline = getBookingTimer();
      const unit = getSelectedUnit();
      const numberRef = getHoldNumberRef();
      if (deadline && deadline > Date.now()) {
        this.step = 3;
        this.bookingDeadline = deadline;
        this.remaining = Math.round((deadline - Date.now()) / 1000);
        this.numberRef = numberRef;
        if (unit) {
          this.selectedUnit = unit;
          this.selectedUnitIndex = (this.units || []).findIndex(
            (u) =>
              (u._id || u.InventoryID) === (unit._id || unit.InventoryID)
          );
          this.price = unit && unit.Cost != null ? unit.Cost : this.price;
        }
        this.startTimer();
      } else if (deadline) {
        removeBookingTimer();
        removeSelectedUnit();
        removeHoldNumberRef();
        this.step = 2;
      } else {
        this.step = 2;
      }
    },
    openAlertTimeout(title = "El tiempo de reserva ha expirado") {
      this.alertTimeout.title = title;
      this.alertTimeout.close = this.closeAlertTimeout;
      this.alertTimeout.show = true;
    },
    closeAlertTimeout() {
      this.alertTimeout.show = false;
    },
    openGallery() {
      this.$refs.item1[0].click();
      // console.log(this.$refs.item1[0].click())
    },
    selectUnit(unit, index) {
      this.selectedUnit = unit;
      this.selectedUnitIndex = index;
      this.price = unit && unit.Cost != null ? unit.Cost : this.price;
      const el = document.getElementById("section-units");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    wtPillClass(name) {
      const n = (name || "").toLowerCase();
      if (n.includes("smart")) return "wtp-smart";
      if (n.includes("vip")) return "wtp-vip";
      return "wtp-default";
    },
    perNight(cost) {
      const nights = parseFloat(this.week && this.week.Nights) || 1;
      const c = parseFloat(cost) || 0;
      return Math.round((c / nights) * 100) / 100;
    },
    isFixedPrice(name) {
      const n = (name || "").toLowerCase();
      return n.includes("smart");
    },
  },
};
</script>

<style scoped>
:root {
  --s-color-brand-primary: #0472aa;
  --s-color-brand-primary-hsl-hue: 200;
  --s-color-brand-primary-hsl-saturation: 95%;
  --s-color-brand-primary-hsl-light: 34%;
  --s-color-brand-primary-red: 4;
  --s-color-brand-primary-green: 114;
  --s-color-brand-primary-blue: 170;

  --s-color-brand-dark: #00527c;
  --s-color-brand-dark-hsl-hue: 200;
  --s-color-brand-dark-hsl-saturation: 100%;
  --s-color-brand-dark-hsl-light: 24%;
  --s-color-brand-dark-red: 0;
  --s-color-brand-dark-green: 82;
  --s-color-brand-dark-blue: 124;

  --s-color-searchbox-background: #00527c;
  --s-color-searchbox-background-hsl-hue: 200;
  --s-color-searchbox-background-hsl-saturation: 100%;
  --s-color-searchbox-background-hsl-light: 24%;
  --s-color-searchbox-background-red: 0;
  --s-color-searchbox-background-green: 82;
  --s-color-searchbox-background-blue: 124;

  --s-color-searchbox-text: #393939;
  --s-color-searchbox-text-hsl-hue: 0;
  --s-color-searchbox-text-hsl-saturation: 0%;
  --s-color-searchbox-text-hsl-light: 22%;
  --s-color-searchbox-text-red: 57;
  --s-color-searchbox-text-green: 57;
  --s-color-searchbox-text-blue: 57;

  --s-color-footer-background: #00527c;
  --s-color-footer-background-hsl-hue: 200;
  --s-color-footer-background-hsl-saturation: 100%;
  --s-color-footer-background-hsl-light: 24%;
  --s-color-footer-background-red: 0;
  --s-color-footer-background-green: 82;
  --s-color-footer-background-blue: 124;

  --s-color-footer-text: #393939;
  --s-color-footer-text-hsl-hue: 0;
  --s-color-footer-text-hsl-saturation: 0%;
  --s-color-footer-text-hsl-light: 22%;
  --s-color-footer-text-red: 57;
  --s-color-footer-text-green: 57;
  --s-color-footer-text-blue: 57;
}

.noIcon {
  background: none;
}

.c-sb-input__field {
  padding-left: 40px;
}

#img-mobile {
  img:hover {
    opacity: 0.8;
    width: 500px;
  }
}

.resort-detail-wrap {
  width: 100%;
}

.traveler-step-wrap {
  width: 100%;
  padding: 20px 0 40px;
}

.resort-progress-host {
  width: 100%;
}

.resort-progress {
  margin: 16px 0 12px;
  padding: 0;
}

.progress .progress-inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress .step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-width: 60px;
}

.progress .step-circle {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  border: 2px solid #cfd8dc;
  background: #fff;
  color: #78909c;
}

.progress .step.done .step-circle {
  background: #2e7d32;
  border-color: #2e7d32;
  color: #fff;
}

.progress .step.active .step-circle {
  background: #0472aa;
  border-color: #0472aa;
  color: #fff;
}

.progress .step.pending .step-circle {
  background: #fff;
  border-color: #cfd8dc;
  color: #90a4ae;
}

.progress .step-label {
  margin-top: 6px;
  font-size: 11px;
  color: #455a64;
}

.progress .step.done .step-label,
.progress .step.active .step-label {
  color: #263238;
  font-weight: 600;
}

.progress .step-line {
  flex: 1;
  height: 2px;
  background: #cfd8dc;
  margin: 0 6px;
  margin-bottom: 22px;
  min-width: 24px;
}

.progress .step-line.done {
  background: #2e7d32;
}

.resort-title-block {
  margin: 12px 0 0;
  width: 100%;
  padding: 0;
}

.resort-cols-wrap {
  width: 100%;
}

.resort-content-col {
  padding-left: 0;
}

@media (min-width: 768px) {
  .resort-content-col {
    padding-right: 20px;
  }
}

.resort-summary-col {
  padding-left: 0;
}

@media (min-width: 768px) {
  .resort-cols-wrap {
    display: flex;
    align-items: stretch;
  }
  .resort-summary-col .summary-col {
    position: sticky;
    top: 16px;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
  }
}

.summary-card {
  background: #fff;
  border: 1px solid #e0e6ea;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
}

.sc-body {
  padding: 14px;
}

.nr-banner {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: #fff4f2;
  border: 1px solid #f3c9bf;
  color: #9a3412;
  padding: 12px 14px;
  border-radius: 10px;
  font-size: 13px;
  margin-bottom: 14px;
}

.nr-banner svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 1px;
}

.sec-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  color: #102a43;
  margin-bottom: 10px;
}

.sec-title svg {
  width: 20px;
  height: 20px;
  color: #0472aa;
}

.units-table-wrap {
  overflow-x: auto;
  border: 1px solid #e0e6ea;
  border-radius: 10px;
}

.units-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.units-table thead th {
  text-align: center;
  padding: 10px 12px;
  background: #f5f7fa;
  color: #334e68;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #e0e6ea;
}

.units-table tbody td {
  padding: 12px;
  border-bottom: 1px solid #eef1f4;
  vertical-align: middle;
  text-align: center;
}

.units-table tbody tr {
  cursor: pointer;
  transition: background 0.15s ease;
}

.units-table tbody tr:hover {
  background: #f6f9fc;
}

.units-table tbody tr.is-selected {
  background: #eaf4fb;
  box-shadow: inset 4px 0 0 #0472aa;
}

.wt-pill {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.wt-pill.wtp-vip {
  background: #fff5d6;
  color: #8a6d1b;
}

.wt-pill.wtp-smart {
  background: #e3f2fd;
  color: #1565c0;
}

.wt-pill.wtp-default {
  background: #eceff1;
  color: #455a64;
}

.unit-price {
  font-weight: 800;
  color: #102a43;
}

.unit-ppn {
  font-size: 12px;
  color: #627d98;
}

.book-btn {
  background: #0472aa;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-weight: 700;
  cursor: pointer;
}

.book-btn:hover {
  background: #00527c;
}

.resort-skeleton {
  width: 100%;
}

.sk {
  background: #eceff1;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: block;
}

.sk::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.6),
    transparent
  );
  transform: translateX(-100%);
  animation: sk-shimmer 1.4s infinite;
}

@keyframes sk-shimmer {
  100% {
    transform: translateX(100%);
  }
}

.sk-line {
  height: 14px;
  margin-bottom: 10px;
}

.sk-line--lg {
  height: 22px;
  margin-bottom: 12px;
}

.sk-line--md {
  height: 16px;
  margin-bottom: 10px;
}

.sk-line--sm {
  height: 12px;
  margin-bottom: 10px;
}

.sk-img-grid {
  width: 100%;
  aspect-ratio: 2.4 / 1;
  margin-bottom: 20px;
}

.sk-amen-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 20px 0;
}

.sk-amen {
  width: 150px;
  height: 44px;
  flex-shrink: 0;
}

.sk-table-row {
  width: 100%;
  height: 48px;
  margin-bottom: 8px;
}

.sk-sc-img {
  width: 100%;
  aspect-ratio: 1.25 / 1;
}

.sk-sc-row {
  height: 16px;
  margin: 10px 0;
}

.sk-book-btn {
  height: 40px;
  width: 120px;
  margin-top: 16px;
}

.mb-btn--disabled {
  opacity: 0.6;
  pointer-events: none;
}

.mb-price {
  font-weight: 800;
  font-size: 15px;
}

.mb-sep {
  opacity: 0.7;
  margin: 0 4px;
}

.mb-timer {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.mb-timer--warn {
  color: #ffd9d2;
}

.mobile-summary-head {
  display: flex;
  justify-content: flex-end;
  padding: 8px 10px;
  border-bottom: 1px solid #e0e6ea;
}

.mobile-summary-close {
  background: none;
  border: none;
  font-size: 20px;
  color: #627d98;
  cursor: pointer;
  line-height: 1;
  padding: 4px 8px;
}

.mobile-summary-close:hover {
  color: #102a43;
}

.mobile-summary-body {
  padding: 12px;
}

@media (max-width: 767px) {
  .resort-detail-wrap {
    padding-bottom: 80px;
  }
}
</style>

<style>
@media (max-width: 767px) {
  .mobile-summary-modal.vm--modal {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
    overflow-y: auto !important;
  }
}
</style>
